import { IQueryPuids } from '../../../repositories/dailyrent/entities/query_puids/QueryPuids';

/** Преобразование puids в Record<string, string | null> для передачи в микрофронтенд */
export function serializePuids(puids: IQueryPuids | null): Record<string, string | null> | null {
  if (!puids) {
    return null;
  }

  const result: Record<string, string | null> = {};

  for (const [key, value] of Object.entries(puids)) {
    result[key] = value ?? null;
  }

  return result;
}
